import a04Model from '@/components/models/A04';
import a05Model from '@/components/models/A05';
import a06Model from '@/components/models/A06';
import a22Model from '@/components/models/A22';
import a36Model from '@/components/models/A36';

import parts from '@/components/parts';

const manual = {
  models: [
    {
      id: 'a04',
      slug: 'a-04',
      name: 'Sans-date',
      vueComponent: a04Model,
      tutorialMode: false,
      tutorialStep: undefined,
      isRunning: true,
      timeout: undefined,
      now: undefined,
      time: {
        hour: 0,
        minute: 0,
        second: 0,
        day: 1,
        weekday: 1,
      },
      movement: 'R513',
      components: {
        strap: {
          displayOnly: true,
          id: 'Strap_A-04',
          role: 'strap',
          type: 'strap',
          component: parts.strap,
        },
        dial: {
          displayOnly: true,
          id: 'Dial_A-04',
          role: 'dial',
          type: 'dial',
          component: parts.dial,
          parent: 'A-04',
        },
        watchCase: {
          displayOnly: true,
          id: 'Case_A-04',
          role: 'watchCase',
          type: 'watchCase',
          component: parts.watchCase,
          parent: 'A-04',
        },
        hour: {
          id: 'Hour_A-04',
          role: 'timeHour',
          type: 'hand',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 110,
          value: 0,
        },
        minute: {
          id: 'Minute_A-04',
          role: 'timeMinute',
          type: 'hand',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 110,
          value: 0,
        },
        second: {
          id: 'Second_A-04',
          role: 'timeSecond',
          type: 'hand',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 110,
          value: 0,
        },
        crown: {
          id: 'Crown_A-04',
          role: 'functionCrown',
          type: 'crown',
          element: undefined,
          component: parts.crown,
          wrapperId: 'CrownAndArrows_A-04',
          wrapperElement: undefined,
          arrowElements: [
            {
              id: 'Arrow_clockwise_A-04',
              element: undefined,
              direction: 1,
              onClick: 'setTime',
              get clickParams() { return [this]; },
            },
            {
              id: 'Arrow_counterclockwise_A-04',
              element: undefined,
              direction: -1,
              onClick: 'setTime',
              get clickParams() { return [this]; },
            },
          ],
          parent: 'a04',
          value: 0,
          functions: [
            {
              position: 0,
              options: [],
              running: true,
            },
            {
              position: 1,
              options: [
                {
                  name: 'Set hour and minute hands',
                  type: 'setTime',
                  direction: 0,
                  highlight: ['hour', 'minute'],
                },
              ],
              running: false,
            },
          ],
          onHover: 'toggleHover',
          isHovered: false,
          get hoverParams() { return [this, this.isHovered]; },
          onClick: 'interpretCrown',
          get clickParams() { return [this]; },
        },
      },
    },
    {
      id: 'a05',
      slug: 'a-05',
      name: 'Field watch',
      vueComponent: a05Model,
      tutorialMode: false,
      tutorialStep: undefined,
      isRunning: true,
      timeout: undefined,
      now: undefined,
      time: {
        hour: 0,
        minute: 0,
        second: 0,
        day: 1,
        weekday: 1,
      },
      movement: 'R515',
      components: {
        strap: {
          displayOnly: true,
          id: 'Strap_A-05',
          role: 'strap',
          type: 'strap',
          component: parts.strap,
        },
        dial: {
          displayOnly: true,
          id: 'Dial_A-05',
          role: 'dial',
          type: 'dial',
          component: parts.dial,
          parent: 'A-05',
        },
        watchCase: {
          displayOnly: true,
          id: 'Case_A-05',
          role: 'watchCase',
          type: 'watchCase',
          component: parts.watchCase,
          parent: 'A-05',
        },
        hour: {
          id: 'Hour_A-05',
          role: 'timeHour',
          type: 'hand',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 110,
          value: 0,
        },
        minute: {
          id: 'Minute_A-05',
          role: 'timeMinute',
          type: 'hand',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 110,
          value: 0,
        },
        second: {
          id: 'Second_A-05',
          role: 'timeSecond',
          type: 'hand',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 110,
          value: 0,
        },
        day: {
          id: 'Day-ring_A-05',
          role: 'timeDay',
          type: 'calendar',
          element: undefined,
          component: parts.calendar,
          cx: 72,
          cy: 110,
          value: 0,
        },
        crown: {
          id: 'Crown_A-05',
          role: 'functionCrown',
          type: 'crown',
          element: undefined,
          component: parts.crown,
          wrapperId: 'CrownAndArrows_A-05',
          wrapperElement: undefined,
          arrowElements: [
            {
              id: 'Arrow_clockwise_A-05',
              element: undefined,
              direction: 1,
              onClick: 'setTime',
              get clickParams() { return [this]; },
            },
            {
              id: 'Arrow_counterclockwise_A-05',
              element: undefined,
              direction: -1,
              onClick: 'setTime',
              get clickParams() { return [this]; },
            },
          ],
          parent: 'a05',
          value: 0,
          functions: [
            {
              position: 0,
              options: [],
              running: true,
            },
            {
              position: 1,
              options: [
                {
                  name: 'Set the day',
                  type: 'setDay',
                  direction: 1,
                  highlight: ['day'],
                },
              ],
              running: true,
            },
            {
              position: 2,
              options: [
                {
                  name: 'Set hour and minute hands',
                  type: 'setTime',
                  direction: 0,
                  highlight: ['hour', 'minute'],
                },
              ],
              running: false,
            },
          ],
          onHover: 'toggleHover',
          isHovered: false,
          get hoverParams() { return [this, this.isHovered]; },
          onClick: 'interpretCrown',
          get clickParams() { return [this]; },
        },
      },
    },
    {
      id: 'a06',
      slug: 'a-06',
      name: 'Day-date',
      vueComponent: a06Model,
      tutorialMode: false,
      tutorialStep: undefined,
      isRunning: true,
      timeout: undefined,
      now: undefined,
      time: {
        hour: 0,
        minute: 0,
        second: 0,
        day: 1,
        weekday: 1,
      },
      movement: 'R517',
      components: {
        strap: {
          displayOnly: true,
          id: 'Strap_A-06',
          role: 'strap',
          type: 'strap',
          component: parts.strap,
        },
        dial: {
          displayOnly: true,
          id: 'Dial_A-06',
          role: 'dial',
          type: 'dial',
          component: parts.dial,
          parent: 'A-06',
        },
        watchCase: {
          displayOnly: true,
          id: 'Case_A-06',
          role: 'watchCase',
          type: 'watchCase',
          component: parts.watchCase,
          parent: 'A-06',
        },
        hour: {
          id: 'Hour_A-06',
          role: 'timeHour',
          type: 'hand',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 110,
          value: 0,
        },
        minute: {
          id: 'Minute_A-06',
          role: 'timeMinute',
          type: 'hand',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 110,
          value: 0,
        },
        second: {
          id: 'Second_A-06',
          role: 'timeSecond',
          type: 'hand',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 110,
          value: 0,
        },
        weekday: {
          id: 'Weekday-ring_A-06',
          role: 'timeWeekday',
          type: 'calendar',
          element: undefined,
          component: parts.calendar,
          cx: 72,
          cy: 110,
          value: 0,
        },
        day: {
          id: 'Day-ring_A-06',
          role: 'timeDay',
          type: 'calendar',
          element: undefined,
          component: parts.calendar,
          cx: 72,
          cy: 110,
          value: 0,
        },
        crown: {
          id: 'Crown_A-06',
          role: 'functionCrown',
          type: 'crown',
          element: undefined,
          component: parts.crown,
          wrapperId: 'CrownAndArrows_A-06',
          wrapperElement: undefined,
          arrowElements: [
            {
              id: 'Arrow_clockwise_A-06',
              element: undefined,
              direction: 1,
              onClick: 'setTime', // TODO: Use function.option.type as arrow's onClick
              get clickParams() { return [this]; },
            },
            {
              id: 'Arrow_counterclockwise_A-06',
              element: undefined,
              direction: -1,
              onClick: 'setTime',
              get clickParams() { return [this]; },
            },
          ],
          parent: 'a06',
          value: 0,
          functions: [
            {
              position: 0,
              options: [],
              running: true,
            },
            {
              position: 1,
              options: [
                {
                  name: 'Set the weekday',
                  type: 'setWeekday',
                  direction: -1,
                  highlight: ['weekday'],
                },
                {
                  name: 'Set the day',
                  type: 'setDay',
                  direction: 1,
                  highlight: ['day'],
                },
              ],
              running: true,
            },
            {
              position: 2,
              options: [
                {
                  name: 'Set hour and minute hands',
                  type: 'setTime',
                  direction: 0,
                  highlight: ['hour', 'minute'],
                },
              ],
              running: false,
            },
          ],
          onHover: 'toggleHover',
          isHovered: false,
          get hoverParams() { return [this, this.isHovered]; },
          onClick: 'interpretCrown',
          get clickParams() { return [this]; },
        },
      },
    },
    {
      id: 'a22',
      slug: 'a-22',
      name: 'Bi-compact chronograph',
      vueComponent: a22Model,
      tutorialMode: false,
      tutorialStep: undefined,
      isRunning: true,
      timeout: undefined,
      now: undefined,
      time: {
        hour: 0,
        minute: 0,
        second: 0,
        day: 1,
        weekday: 1,
      },
      chronoRunning: false,
      chronoInterval: false,
      chronoNow: undefined,
      chronoTimeout: undefined,
      chrono: {
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
        interval: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          milliseconds: 0,
        },
        zero: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          milliseconds: 0,
        },
      },
      movement: 'R3520',
      components: {
        strap: {
          displayOnly: true,
          id: 'Strap_A-22',
          role: 'strap',
          type: 'strap',
          component: parts.strap,
        },
        dial: {
          displayOnly: true,
          id: 'Dial_A-22',
          role: 'dial',
          type: 'dial',
          component: parts.dial,
          parent: 'A-22',
        },
        watchCase: {
          displayOnly: true,
          id: 'Case_A-22',
          role: 'watchCase',
          type: 'watchCase',
          component: parts.watchCase,
          parent: 'A-22',
        },
        day: {
          id: 'Day-ring_A-22',
          role: 'timeDay',
          type: 'calendar',
          element: undefined,
          component: parts.calendar,
          cx: 72,
          cy: 110,
          value: 0,
        },
        chronoH: {
          id: 'Chrono_Hour_A-22',
          role: 'chronoHour',
          type: 'hand',
          parent: 'A-22',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 88.94,
          value: 0,
        },
        chronoM: {
          id: 'Chrono_Minute_A-22',
          role: 'chronoMinute',
          type: 'hand',
          parent: 'A-22',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 88.94,
          value: 0,
        },
        smallSecond: {
          id: 'Small_Second_A-22',
          role: 'timeSecond',
          type: 'hand',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 131.454,
          value: 0,
        },
        hour: {
          id: 'Hour_A-22',
          role: 'timeHour',
          type: 'hand',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 110,
          value: 0,
        },
        minute: {
          id: 'Minute_A-22',
          role: 'timeMinute',
          type: 'hand',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 110,
          value: 0,
        },
        second: {
          id: 'Second_A-22',
          role: 'chronoSecond',
          type: 'hand',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 110,
          value: 0,
        },
        crown: {
          id: 'Crown_A-22',
          role: 'functionCrown',
          type: 'crown',
          element: undefined,
          component: parts.crown,
          wrapperId: 'CrownAndArrows_A-22',
          wrapperElement: undefined,
          arrowElements: [
            {
              id: 'Arrow_clockwise_A-22',
              element: undefined,
              direction: 1,
              onClick: 'setTime',
              get clickParams() { return [this]; },
            },
            {
              id: 'Arrow_counterclockwise_A-22',
              element: undefined,
              direction: -1,
              onClick: 'setTime',
              get clickParams() { return [this]; },
            },
          ],
          parent: 'a22',
          value: 0,
          functions: [
            {
              position: 0,
              options: [],
              running: true,
            },
            {
              position: 1,
              options: [
                {
                  name: 'Set the day',
                  type: 'setDay',
                  direction: 1,
                  highlight: ['day'],
                },
              ],
              running: true,
            },
            {
              position: 2,
              options: [
                {
                  name: 'Set hour and minute hands',
                  type: 'setTime',
                  direction: 0,
                  highlight: ['hour', 'minute'],
                },
                {
                  name: 'Reset counters',
                  type: 'resetCounters',
                  direction: undefined,
                },
              ],
              running: false,
            },
          ],
          onHover: 'toggleHover',
          isHovered: false,
          get hoverParams() { return [this, this.isHovered]; },
          onClick: 'interpretCrown',
          get clickParams() { return [this]; },
        },
        pusherA: {
          id: 'Pusher-A_A-22',
          role: 'functionPusherA',
          type: 'pusher',
          element: undefined,
          component: parts.pusher,
          parent: 'a22',
          value: 0,
          onHover: 'toggleHover',
          isHovered: false,
          get hoverParams() { return [this, this.isHovered]; },
          onClick: 'interpretChrono',
          get clickParams() { return [this]; },
        },
        pusherB: {
          id: 'Pusher-B_A-22',
          role: 'functionPusherB',
          type: 'pusher',
          element: undefined,
          component: parts.pusher,
          parent: 'a22',
          value: 0,
          onHover: 'toggleHover',
          isHovered: false,
          get hoverParams() { return [this, this.isHovered]; },
          onClick: 'interpretChrono',
          get clickParams() { return [this]; },
        },
      },
    },
    {
      id: 'a36',
      slug: 'a-36',
      name: 'Three-eye chronograph',
      vueComponent: a36Model,
      tutorialMode: false,
      tutorialStep: undefined,
      isRunning: true,
      timeout: undefined,
      now: undefined,
      time: {
        hour: 0,
        minute: 0,
        second: 0,
        day: 1,
        weekday: 1,
      },
      chronoRunning: false,
      chronoInterval: false,
      chronoNow: undefined,
      chronoTimeout: undefined,
      chrono: {
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
        interval: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          milliseconds: 0,
        },
        zero: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          milliseconds: 0,
        },
      },
      movement: 'R3540',
      components: {
        strap: {
          displayOnly: true,
          id: 'Strap_A-36',
          role: 'strap',
          type: 'strap',
          component: parts.strap,
        },
        dial: {
          displayOnly: true,
          id: 'Dial_A-36',
          role: 'dial',
          type: 'dial',
          component: parts.dial,
          parent: 'A-36',
        },
        watchCase: {
          displayOnly: true,
          id: 'Case_A-36',
          role: 'watchCase',
          type: 'watchCase',
          component: parts.watchCase,
          parent: 'A-36',
        },
        day: {
          id: 'Day-ring_A-36',
          role: 'timeDay',
          type: 'calendar',
          element: undefined,
          component: parts.calendar,
          cx: 72,
          cy: 110,
          value: 0,
        },
        chronoH: {
          id: 'Chrono_Hour_A-36',
          role: 'chronoHour',
          type: 'hand',
          parent: 'A-36',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 88.744,
          value: 0,
        },
        chronoM: {
          id: 'Chrono_Minute_A-36',
          role: 'chronoMinute',
          type: 'hand',
          parent: 'A-36',
          element: undefined,
          component: parts.hand,
          cx: 52.364,
          cy: 110,
          value: 0,
        },
        smallSecond: {
          id: 'Small_Second_A-36',
          role: 'timeSecond',
          type: 'hand',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 131.266,
          value: 0,
        },
        hour: {
          id: 'Hour_A-36',
          role: 'timeHour',
          type: 'hand',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 110,
          value: 0,
        },
        minute: {
          id: 'Minute_A-36',
          role: 'timeMinute',
          type: 'hand',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 110,
          value: 0,
        },
        second: {
          id: 'Chrono_Second_A-36',
          role: 'chronoSecond',
          type: 'hand',
          element: undefined,
          component: parts.hand,
          cx: 72,
          cy: 110,
          value: 0,
        },
        crown: {
          id: 'Crown_A-36',
          role: 'functionCrown',
          type: 'crown',
          element: undefined,
          component: parts.crown,
          wrapperId: 'CrownAndArrows_A-36',
          wrapperElement: undefined,
          arrowElements: [
            {
              id: 'Arrow_clockwise_A-36',
              element: undefined,
              direction: 1,
              onClick: 'setTime',
              get clickParams() { return [this]; },
            },
            {
              id: 'Arrow_counterclockwise_A-36',
              element: undefined,
              direction: -1,
              onClick: 'setTime',
              get clickParams() { return [this]; },
            },
          ],
          parent: 'a36',
          value: 0,
          functions: [
            {
              position: 0,
              options: [],
              running: true,
            },
            {
              position: 1,
              options: [
                {
                  name: 'Set the day',
                  type: 'setDay',
                  direction: 1,
                  highlight: ['day'],
                },
              ],
              running: true,
            },
            {
              position: 2,
              options: [
                {
                  name: 'Set hour and minute hands',
                  type: 'setTime',
                  direction: 0,
                  highlight: ['hour', 'minute'],
                },
                {
                  name: 'Reset counters',
                  type: 'resetCounters',
                  direction: undefined,
                },
              ],
              running: false,
            },
          ],
          onHover: 'toggleHover',
          isHovered: false,
          get hoverParams() { return [this, this.isHovered]; },
          onClick: 'interpretCrown',
          get clickParams() { return [this]; },
        },
        pusherA: {
          id: 'Pusher-A_A-36',
          role: 'functionPusherA',
          type: 'pusher',
          element: undefined,
          component: parts.pusher,
          parent: 'a36',
          value: 0,
          onHover: 'toggleHover',
          isHovered: false,
          get hoverParams() { return [this, this.isHovered]; },
          onClick: 'interpretChrono',
          get clickParams() { return [this]; },
        },
        pusherB: {
          id: 'Pusher-B_A-36',
          role: 'functionPusherB',
          type: 'pusher',
          element: undefined,
          component: parts.pusher,
          parent: 'a36',
          value: 0,
          onHover: 'toggleHover',
          isHovered: false,
          get hoverParams() { return [this, this.isHovered]; },
          onClick: 'interpretChrono',
          get clickParams() { return [this]; },
        },
      },
    },
  ],
};

export default manual;
